import gql from "graphql-tag";
const createSimMutation = gql(`
mutation createSim($input: simInput!) {
  createSim(input: $input) {
  id
  sub
  sample
  coords
  mode
  sim
  }
}
`)
export default createSimMutation;
